import React from 'react';
import {Button, ButtonGroup, Container, Paper} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {DeleteOutline} from "@mui/icons-material";

const buttonSx = {
    padding: 0,
    minWidth: '25px !important',
    height: '25px',
    width: '25px'
}

function Counter({setCount, count, disablePlus, disableMinus, minValue, pt, disabled}) {
    const handleChange = (value) => {
        const number = disableMinus ? Math.max(value, (minValue || 0)) : value;
        setCount(number);
    };

    return (
        <Container disableGutters sx={{pt: pt || 'initial', width: 'initial', margin: 0}}>
            {disabled ? <Button sx={buttonSx} color={"secondary"}
                                onClick={() => handleChange(count - 1)}
                                disabled={disableMinus}
            >
                <DeleteOutline fontSize="small" sx={{padding: 0}}/>
            </Button> : <ButtonGroup>
                <Button sx={buttonSx} color={"secondary"}
                        onClick={() => handleChange(count - 1)}
                        disabled={disableMinus}
                >
                    {(!disableMinus && count === minValue) ? <DeleteOutline fontSize="small" sx={{padding: 0}}/> :
                        <RemoveIcon fontSize="small" sx={{padding: 0}}/>}
                </Button>
                <Paper sx={{width: '37px', textAlign: 'center', height: '25px'}} variant={'outlined'}
                       square>{count}</Paper>
                <Button sx={buttonSx}
                        onClick={() => handleChange(count + 1)}
                        color={"secondary"}
                        disabled={disablePlus}
                >
                    <AddIcon fontSize="small" sx={{padding: 0}}/>
                </Button>
            </ButtonGroup>}
        </Container>
    );
}

export default Counter;